import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "infobar"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle1" }
const _hoisted_5 = { class: "subtitle2" }
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@treebal.green" }, "support@treebal.green", -1)
const _hoisted_8 = { class: "stepstitle" }
const _hoisted_9 = { class: "stepsnumbers" }
const _hoisted_10 = {
  class: "step",
  id: "step-1"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = { class: "explanation" }
const _hoisted_14 = {
  class: "step hide",
  id: "step-2"
}
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "description" }
const _hoisted_17 = { class: "explanation" }
const _hoisted_18 = {
  class: "step hide",
  id: "step-3"
}
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "description" }
const _hoisted_21 = { class: "explanation" }
const _hoisted_22 = {
  class: "step hide",
  id: "step-4"
}
const _hoisted_23 = { class: "name" }
const _hoisted_24 = { class: "description" }
const _hoisted_25 = { class: "explanation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.userOrganization.lockedDate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("infobar.demo.title")), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("infobar.demo.subtitle1")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("infobar.demo.subtitle2", { date: _ctx.lockedDate })), 1),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t("infobar.demo.contact")) + " ", 1),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("infobar.demo.stepstitle")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              id: "btn-1",
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectStep(1)))
            }, " 1 "),
            _createElementVNode("button", {
              id: "btn-2",
              type: "button",
              class: "btn btn-outline-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectStep(2)))
            }, " 2 "),
            _createElementVNode("button", {
              id: "btn-3",
              type: "button",
              class: "btn btn-outline-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectStep(3)))
            }, " 3 "),
            _createElementVNode("button", {
              id: "btn-4",
              type: "button",
              class: "btn btn-outline-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectStep(4)))
            }, " 4 ")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("infobar.demo.steps.1.title")), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("infobar.demo.steps.1.description")), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("infobar.demo.steps.1.explanation")), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("infobar.demo.steps.2.title")), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("infobar.demo.steps.2.description")), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("infobar.demo.steps.2.explanation")), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("infobar.demo.steps.3.title")), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("infobar.demo.steps.3.description")), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("infobar.demo.steps.3.explanation")), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("infobar.demo.steps.4.title")), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("infobar.demo.steps.4.description")), 1),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("infobar.demo.steps.4.explanation")), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}